module.exports = __webpack_public_path__ + "static/7-b7a0398add77272acdfdffabc9f881b4.jpg";